<!-- Summary & Filters Header -->
<div class="alert-list-header">
  <div class="row align-items-center">
    <!-- Summary Counts -->
    <div class="col-auto">
      <ul class="summary-counts clearfix">
        <li>
          <span class="bold">{{"GENERICS.ACTIVE" | translate}}:</span>
          {{alertsSummary?.activeTotal ?? 0}}
        </li>
        <li>
          <span class="bold">{{"GENERICS.ARCHIVED" | translate}}:</span>
          {{alertsSummary?.archivedTotal ?? 0}}
        </li>
      </ul>
    </div>

    <!-- Filter Toggles -->
    <div class="col d-flex align-items-center justify-content-end flex-wrap filter-toggles">
      <div class="filter-toggle-item">
        <label class="toggle-label">{{"MY_ALERTS.CREATED_BY_ME" | translate}}</label>
        <ui-switch size="small"
          [ngModel]="alertsByMe"
          (change)="alertsByMe = $event; onFilterChange()">
        </ui-switch>
      </div>
      <div class="filter-toggle-item">
        <label class="toggle-label">{{"MY_ALERTS.ASSIGNED_TO_ME" | translate}}</label>
        <ui-switch size="small"
          [ngModel]="alertsToMe"
          (change)="alertsToMe = $event; onFilterChange()">
        </ui-switch>
      </div>
      <div class="filter-toggle-item">
        <label class="toggle-label">{{"MY_ALERTS.SHOW_ARCHIVED" | translate}}</label>
        <ui-switch size="small"
          [ngModel]="showArchived"
          (change)="showArchived = $event; onShowArchivedChange()">
        </ui-switch>
      </div>
    </div>
  </div>
</div>

<!-- Alert Table -->
<div class="alert-list-content">
  <div class="h-scrollable-wrapper">
    <div class="h-scrollable">
      <ng-container *ngIf="alertList?.length > 0; else noDataAvailable">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th *ngIf="showCompanyColumn">{{"MY_COMPANIES.COMPANY_NAME" | translate}}</th>
              <th>{{"DATE.DATE" | translate}}</th>
              <th>{{"DATE.TIME" | translate}}</th>
              <th>{{"MY_ALERTS.EVENT_TYPE" | translate}}</th>
              <th>{{"TABLE.CREATOR" | translate}}</th>
              <th>{{"MY_ALERTS.ASSIGNED_TO" | translate}}</th>
              <th>{{"GENERICS.DESCRIPTION" | translate}}</th>
              <th>{{"MY_ALERTS.REPEAT" | translate}}</th>
              <th>{{"MY_ALERTS.FREQUENCY" | translate}}</th>
              <th>{{"MY_ALERTS.INSTANCE" | translate}}</th>
              <th class="table-actions-column-mid"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of alertList">
              <!-- Company Name (conditional) -->
              <td *ngIf="showCompanyColumn">
                <a [routerLink]="['/company', item.company?.id]"
                   *ngIf="permissions.read; else companyAsText">
                  {{item.company?.name}}
                </a>
                <ng-template #companyAsText>
                  {{item.company?.name}}
                </ng-template>
              </td>
              <!-- Date -->
              <td>{{item.alert?.alertTriggerDatetime | rmsTzFormat: formatEST: verboseDateFormat}}</td>
              <!-- Time -->
              <td>{{item.alert?.alertTriggerDatetime | rmsTzFormat: formatEST: timeFormat}}</td>
              <!-- Event Type -->
              <td>{{item.alert?.alertType}}</td>
              <!-- Creator -->
              <td>
                <ng-container *ngIf="item.createdBy">
                  {{item.createdBy.firstName}} {{item.createdBy.lastName}}
                </ng-container>
              </td>
              <!-- Assigned To -->
              <td>
                <ng-container *ngFor="let userGroup of item.alert?.userGroups; let isLast = last">
                  <span>{{userGroup.name}}{{isLast ? '' : ', '}}</span>
                </ng-container>
                <ng-container *ngIf="item.alert?.userGroups?.length > 0 && item.alert?.users?.length > 0">, </ng-container>
                <ng-container *ngFor="let user of item.alert?.users; let isLast = last">
                  <span>{{user.fullName}}{{isLast ? '' : ', '}}</span>
                </ng-container>
              </td>
              <!-- Description -->
              <td>{{item.alert?.manualAlert?.alertText}}</td>
              <!-- Repeat -->
              <td>{{item.alert?.repeatAlert}}</td>
              <!-- Frequency -->
              <td>{{item.alert?.alertFrequencyName}}</td>
              <!-- Instance -->
              <td>
                {{item.alert?.instanceCount > 0
                  ? item.alert.instanceCount
                  : (item.alert?.indefiniteInstance
                    ? ('GENERICS.INFINITE' | translate | lowercase)
                    : '')}}
              </td>
              <!-- Actions -->
              <td class="text-center">
                <ng-container *ngIf="!item.alert?.isProcessed">
                  <!-- Unassign -->
                  <button class="btn btn-link table-action table-action-unassign"
                          *ngIf="permissions.alertRead && isCurrentUserAssigned(item)"
                          [swal]="{title: translations['GENERICS.UNASSIGN_TITLE'], showCloseButton: true,
                            html: templateModal('UNASSIGN', 'Name', item.company?.name),
                            confirmButtonText: translations['GENERICS.UNASSIGN'],
                            cancelButtonText: translations['GENERICS.CANCEL']}"
                          (confirm)="unassignAlert(item)">
                    <i class="fa fa-minus" title="Unassign myself from alert"></i>
                  </button>
                  <!-- Assign -->
                  <button class="btn btn-link table-action table-action-assign"
                          (click)="assignAlert(item)"
                          *ngIf="permissions.alertRead && !isCurrentUserAssigned(item)">
                    <i class="fa fa-plus" title="Assign myself to alert"></i>
                  </button>
                  <!-- Edit -->
                  <button class="btn btn-link table-action table-action-edit"
                          (click)="onEdit(item)"
                          *ngIf="permissions.alertUpdate && loggedUserId === item.createdBy?.id">
                    <i class="fa fa-pencil" title="Edit Alert"></i>
                  </button>
                  <!-- Delete -->
                  <button class="btn btn-link table-action table-action-delete"
                          *ngIf="permissions.alertDelete && loggedUserId === item.createdBy?.id"
                          [swal]="{title: translations['GENERICS.DELETE_TITLE'], showCloseButton: true,
                            html: templateModal('DELETE', 'Name', item.company?.name),
                            confirmButtonText: translations['GENERICS.DELETE'],
                            cancelButtonText: translations['GENERICS.CANCEL']}"
                          (confirm)="deleteAlert(item)">
                    <i class="fa fa-trash" title="Delete Alert"></i>
                  </button>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noDataAvailable>
  <rms-no-content></rms-no-content>
</ng-template>

<!-- Pagination -->
<rms-pagination [pagination]="pagination"
                [totalRecords]="totalRecords"
                (onPageChanged)="onPageChanged()"
                (onRecordsPerPageChanged)="onRecordsPerPageChanged()">
</rms-pagination>
